import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '0 0 1rem 1rem',
    maxWidth: 'unset',

    '& .headerContent': {
      borderRadius: '1rem 1rem 0 0',
      paddingTop: '12px'
    }
  }
}))

export default useStyles
